import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Box,
    Breadcrumbs,
    Button,
    Container,
    Step,
    StepButton,
    Stepper,
    Typography,
} from "@mui/material";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import One from "../../components/PatientForm/One";
import Two from "../../components/PatientForm/Two";
// import Three from "../../components/PatientForm/Three";
import Four from "../../components/PatientForm/Four";
import Preview from "../../components/PatientForm/Preview";
import { useCreatePatientCaller } from "./useCreatePatientCaller";

const CreatePatient = () => {
    const [activeStep, setActiveStep] = useState(0);
    const { t } = useTranslation();
    const { onSubmit,
        formValue,
        setFormValue,
        registerGeneral,
        handleSubmitGeneral,
        errorsGeneral,
        registerAddress,
        handleSubmitAddress,
        unRegisterAddress,
        errorsAddress,
        branch,
        appendAddress,
        addressFields,
        addressRemove,
        loading
    } = useCreatePatientCaller();

    const renderSwitch = () => {
        switch (activeStep) {
            case 0:
                return (
                    <One register={registerGeneral} handleSubmit={handleSubmitGeneral} errors={errorsGeneral} setFormValue={setFormValue}
                        formValue={formValue} branch={branch} handleNext={handleComplete}
                    />
                );
            case 1:
                return (
                    <Two register={registerAddress} handleSubmit={handleSubmitAddress} errors={errorsAddress} setFormValue={setFormValue}
                        formValue={formValue} handleNext={handleComplete} append={appendAddress} fields={addressFields} remove={addressRemove}
                        unRegister={unRegisterAddress}
                    />
                );
            // case 2:
            //     return (
            //         <Three register={registerAddress} handleSubmit={handleSubmitAddress} errors={errorsAddress} setFormValue={setFormValue}
            //             formValue={formValue} handleNext={handleComplete}
            //         />
            //     );
            case 2:
                return (
                    <Four register={registerAddress} handleSubmit={handleSubmitAddress} errors={errorsAddress} setFormValue={setFormValue}
                        formValue={formValue} handleNext={handleComplete}
                    />
                );
            case 3:
                return <Preview formValue={formValue} />;

            default:
                break;
        }
    };

    const steps = ["Basic Info", "Address", "Risk Factor and Habits", "Preview"];
    const [completed, setCompleted] = useState<{
        [k: number]: boolean;
    }>({});

    const totalSteps = () => {
        return steps.length;
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const handleNext = () => {
        const newActiveStep =
            isLastStep() && !allStepsCompleted()
                ? // It's the last step, but not all steps have been completed,
                // find the first step that has been completed
                steps.findIndex((step, i) => !(i in completed))
                : activeStep + 1;
        setActiveStep(newActiveStep);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStep = (step: number) => () => {
        if (step in completed) setActiveStep(step);
    };

    const handleComplete = () => {
        const newCompleted = completed;
        newCompleted[activeStep] = true;
        setCompleted(newCompleted);
        handleNext();
    };
    
    return <>
        <Helmet>
            <title>Create Patient</title>
        </Helmet>
        <Container className="bg-amber50 m-12">
            <Breadcrumbs className="p-5" aria-label="breadcrumb">
                <Link color="inherit" to="/" className="hover:underline">
                    Home
                </Link>
                <Link color="inherit" to="/search/patient" className="hover:underline">
                    Search Patient
                </Link>
                <Typography className="text-black">Create Patient</Typography>
            </Breadcrumbs>
            <Stepper nonLinear activeStep={activeStep} alternativeLabel>
                {steps.map((label, index) => (
                    <Step key={label} completed={completed[index]}>
                        <StepButton className="text-red-400" onClick={handleStep(index)}>
                            {label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
            <h1 className="pt-6 pl-16 text-xl font-bold">{t("Create New Patient")}</h1>
            <div className="p-10">
                <Box sx={{ width: "100%" }}>
                    <div>
                        {
                            <>
                                {renderSwitch()}
                                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                                    {activeStep === 5 ? (
                                        <></>
                                    ) : (
                                        <Button
                                            color="inherit"
                                            disabled={activeStep === 0}
                                            onClick={handleBack}
                                            sx={{ mr: 1 }}
                                        >
                                            <>{t("back")}</>
                                        </Button>
                                    )}

                                    <Box sx={{ flex: "1 1 auto" }} />
                                    {activeStep < 3 ? (
                                        <>
                                            <Button
                                                type="submit"
                                                form={`page${activeStep + 1}`}
                                                sx={{ mr: 1 }}
                                            >
                                                <>{t("next")}</>
                                            </Button>
                                        </>
                                    ) : (
                                        <Button onClick={onSubmit} sx={{ mr: 1 }} disabled={loading}>
                                            <>{t("Submit")}</>
                                        </Button>
                                    )}
                                </Box>
                            </>
                        }
                    </div>
                </Box>
            </div>
        </Container>
    </>;
};

export default CreatePatient;
